const CHUNK_LOAD_ERROR = 'ChunkLoadError';

const isChunkLoadError = (err) =>
    err?.name === CHUNK_LOAD_ERROR || err?.message?.includes(CHUNK_LOAD_ERROR);

const bugsnagClient = {
    notify: (err) => {
        if (isChunkLoadError(err)) {
            window.location.reload(true);
            return;
        }
        if (process.env.NODE_ENV !== 'production') {
            console.error('Error encountered: ', err);
        }
    },
};

export const setBugsnagUser = (userName) => {
    bugsnagClient.user = {
        name: userName,
    };
};

export default bugsnagClient;
